import { connect } from 'react-redux';

import Footer from './footer.jsx';

export default connect(
    // mapStateToProps
    state => ( {
        authenticated: state.userData.authenticated,
        participantRules: state.userData.participantRules || []
    } ),
    // mapDispatchToProps
    {}
)( Footer );
